export const cpfCnpjMask = (value) => {
  
  let cleanValue = value.replace(/\D+/g, ''); // Remove tudo que não é número
  if (cleanValue.length > 14) {
    cleanValue = cleanValue.substring(0, 14);
  }
  let maskedValue = '';
  if (cleanValue.length <= 11) { // Se for CPF
    maskedValue = cleanValue.replace(/(\d{3})(\d)/, '$1.$2')
                           .replace(/(\d{3})(\d)/, '$1.$2')
                           .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
  } else { // Se for CNPJ
    maskedValue = cleanValue.replace(/^(\d{2})(\d)/, '$1.$2')
                           .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
                           .replace(/\.(\d{3})(\d)/, '.$1/$2')
                           .replace(/(\d{4})(\d)/, '$1-$2');
  }
  return maskedValue;
};
